import MUIBadge, { BadgeProps as MUIBadgeProps } from '@mui/material/Badge';

import { useStyles } from './Badge.styles';

/**
 * Свойства компонента {@link Badge}
 */
export interface BadgeProps extends MUIBadgeProps {
  /**
   * Определяет, должен ли значок быть видимым.
   *
   * @defaultValue `false`
   */
  visible?: boolean;
}

/**
 * Пользовательский компонент значка, построенный с использованием Material-UI.
 *
 * @public
 * @param visible - Определяет, должен ли значок быть видимым.
 * @param children - Дочерние элементы, которые будут отображаться внутри компонента.
 * @returns Компонент Badge.
 *
 * @remarks
 *
 * Ссылка на свойства компонента {@link BadgeProps}
 */
export const Badge = (props: BadgeProps) => {
  const { visible = false, ...rest } = props;

  const { classes } = useStyles();

  return (
    <MUIBadge
      invisible={!visible}
      variant="dot"
      className={`aqa_badge ${classes.badge}`}
      data-testid="badge-test-id"
      {...rest}
    >
      {props.children}
    </MUIBadge>
  );
};
